import styled from '@emotion/styled'

import media from '../../../styles/media'

const S = {}

S.Legal = styled.ul`
  list-style-type: none;
  padding-left: 0;
  padding-right: 0;
  text-align: center;
  margin-top: 2.1875rem;
  margin-bottom: 2.75rem;

  ${media.md`
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  `};

  .legal-item {
    margin-bottom: 1.5rem;

    ${media.md`
      display: inline-block;
      margin-bottom: 0;

      html:not([dir]) &,
      [dir='ltr'] & {
        margin-right: 1.5rem;
      }

      [dir='rtl'] & {
        margin-left: 1.5rem;
      }
    `};

    &:last-child {
      margin-bottom: 0;

      html:not([dir]) &,
      [dir='ltr'] & {
        margin-right: 0;
      }

      [dir='rtl'] & {
        margin-left: 0;
      }
    }
  }

  .legal-item > span,
  .legal-link,
  .legal-dns span {
    font-size: 0.875rem;
    line-height: 1.29;
    text-decoration: none;
  }

  .legal-dns span {
    transition: color 0.2s ease-in-out;
    cursor: pointer;
  }

  .ccpa {
    display: inline-flex;
    align-items: center;
    column-gap: 0.25rem;
  }
`

export default S
